import { HealthCheckApi } from "../ApiRequests";

/**
 * Verifies browser + server reachability via GET /api/health.
 * @returns {Promise<{ ok: boolean, reason?: string }>}
 */
export async function checkInternetConnection() {
  if (typeof navigator !== "undefined" && !navigator.onLine) {
    return { ok: false, reason: "offline" };
  }

  try {
    const response = await HealthCheckApi();
    if (response?.data?.success) {
      return { ok: true };
    }
    return { ok: false, reason: "server" };
  } catch {
    return { ok: false, reason: "network" };
  }
}
